import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const HeartShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408.6 369.1",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M292.9 0c-30.9-.2-60.6 12-82.4 33.9-3.1 3.1-8.1 3.1-11.2.1-22.1-21.8-51.8-34-82.8-34-31.4 0-60.8 12-82.6 33.9-45.2 45.6-45.2 119.1 0 164.8l170.4 170.4 170.4-170.4c45-45.7 45.2-118.9.5-164.9C353.4 12 323.8-.2 292.9 0z"
    })
  });
};

export { HeartShape };
//# sourceMappingURL=HeartShape.js.map
